import type {
	MessageProps,
	MessageRendererType,
} from '@post-office/placement-common/utils/message-renderer';

import { initializeMessageRenderer } from './__generated__/client/render';

import type { renderer } from './__generated__/client/render';

export const MessageRenderer: MessageRendererType = initializeMessageRenderer();

/**
 * This should ideally be supplied from `./api/render` module together with initializeMessageRenderer
 */
//TODO: This should be the real type of the renderer
export type Message = MessageProps<typeof renderer>;
